export default __webpack_public_path__ + "8fb6947d1141164474ca1fccedebe792.svg";